import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z"
}), 'Functions');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Functions.js
// module id = 3959
// module chunks = 2